import axios from '@/jslib/axios'

export const getHK01List = params => {
  return axios({
    method: 'get',
    url: '/admin/hk01/list',
    params
  })
}
export const getHK01Detail = params => {
  return axios({
    method: 'get',
    url: '/admin/hk01/detail',
    params
  })
}
export const addHK01Remark = data => {
  return axios({
    method: 'post',
    url: '/admin/hk01/remark/add',
    data
  })
}
export const editHK01Email = data => {
  return axios({
    method: 'post',
    url: '/admin/hk01/edit',
    data
  })
}
export const resendHK01Email = data => {
  return axios({
    method: 'post',
    url: '/admin/hk01/resend/email',
    data
  })
}
